import { useState, useEffect, useCallback } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

import { AccordionIconWrapper } from './AccordionV2.styles';

export const AccordionV2 = ({ title, children, defaultIsOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const handleToggle = useCallback(() => setIsOpen((prev) => !prev), []);

  useEffect(() => {
    setIsOpen(defaultIsOpen);
  }, [defaultIsOpen]);

  return (
    <>
      <Box display="flex" gap={2} alignItems="center" mb={2} onClick={handleToggle}>
        <AccordionIconWrapper expanded={isOpen}>
          <ChevronRightIcon fontSize="large" />
        </AccordionIconWrapper>
        <Typography
          variant="h4"
          fontSize="28px"
          lineHeight="28px"
          fontWeight={600}
          fontFamily="Financier"
        >
          {title}
        </Typography>
      </Box>
      <Collapse in={isOpen}>{children}</Collapse>
    </>
  );
};
